import React from "react";
import { useTranslation } from "react-i18next";
import InfoCard from "../../Customer/components/InfoCard";
import { SecurePayment, ShippedIn2To3Days, Verified } from "../../../Constants";
import PaymentMethods from "../../../assets/payment-methods.webp";
import Shipping from "../../../assets/shipping-DHL.webp";
import ReviewsImage from "../../../assets/reviews.webp";

const SecureShippedVerifired = () => {
  const { t } = useTranslation();
  return (
    <div className="t-flex t-items-start t-justify-center t-gap-8">
      <InfoCard
        image={PaymentMethods}
        desc={t(SecurePayment)}
        className="md:!t-w-1/2"
      />
      <InfoCard
        image={Shipping}
        desc={t(ShippedIn2To3Days)}
        pClass="md:t-mt-[10px]"
      />
      <InfoCard
        image={ReviewsImage}
        desc={t(Verified)}
        pClass="md:t-mt-[10px]"
      />
    </div>
  );
};

export default SecureShippedVerifired;
